import CompanyAdmin from './CompanyAdmin';

export default CompanyAdmin;
